<div class="comment-section">
  <ocp-comment-form
    [userInitials]="userInitials()"
    [colorSeed]="userColorSeed()"
    (addComment)="addComment.emit($event)"
  />
  <ocp-comment-list [comments]="comments()" (commentClose)="commentClose.emit($event)" />
</div>
